import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import { TextField, withStyles } from '@material-ui/core';
import prismaBackground from 'assets/img/prismas-background.svg';
import { EnumScreenName } from 'models/login';


interface ItemFormLogin {
  show?: boolean;
  errorMessagePosition?: 'top' | 'bottom';
}

interface LinkStyledProps {
  color?: string;
  alignSelf?: string;
  textDecoration?: string;
  margin?: string;
}

interface CheckboxLogin {
  isCheckbox?: boolean;
}

export const ContainerLeftStyled = styled.div`
  width: 42%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #004597;
  background-image: url(${prismaBackground});
  background-size: cover;
`;

export const ContainerRightStyled = styled.div<{
  screen: EnumScreenName;
  showTermsUse?: boolean;
}>`
  width: 58%;
  font-size: 18px;
  background-color: #F5F7FA;
  font-family: 'Gotham', 'Embedded Open Sans', Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  padding: 0px;
  z-index: 2;
  overflow-y: hidden;
  height: 100vh;

  ${({ screen, showTermsUse }) => (screen === EnumScreenName.TELA_REDEFINICAO_SENHA || showTermsUse) && `
    justify-content: center;
  `}
  
  ${({ screen }) => screen === EnumScreenName.TELA_RECUPERAR_SENHA && `
    padding-top: 144px;
    justify-content: flex-start;

    @media(min-width: 1920px){
      padding-top: 300px;
      padding: 300px 264px;
    }
  `};

  ${({ screen }) => screen === EnumScreenName.TELA_LINK_ENVIADO && `
    padding: 144px 105px 0 129px;
    justify-content: flex-start;

    @media(min-width: 1920px){
      padding: 300px 264px 0;
    }
  `};
  
`;

export const ContainerLoginStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const FormGroupStyled = styled(Form)`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 50%;
  width: 578px;
  padding: 0;
  height: 100%;

  @media (max-width: 1366px) {
    min-width: 80%;
  }
`;

export const InputGroupStyled = styled.div<ItemFormLogin>`
  display: flex;
  ${({ errorMessagePosition }) => errorMessagePosition === 'top' ? `
    gap: 8px;
    flex-direction: column-reverse;
    `
    :
    `
      flex-direction: column;
    `
  }
  align-items: center;
  width: 100%;
  display: ${(props) => (props.show ? 'inherit' : 'none')};

  &.input-group-password {
    margin-top: 16px;
    margin-bottom: 6px;
  }
`;

interface CustomEmailInputProps {
  error: boolean;
  value: string;
}

export const CustomEmailInput = withStyles(({
  root: {
    backgroundColor: '#fff',
    borderRadius: '24px !important',
    border: 'none',

    '& label + .MuiInput-formControl': {
      margin: '0',
      'padding-top': '16px',
    },
 
    '& .MuiInputBase-root.Mui-focused': {
      border: (props: CustomEmailInputProps) => props.value && (props.error ? '1px solid #FF9E80A3': '1px solid #3978D7'),
      'border-radius': '24px',
    },

    '& .MuiInputLabel-root.Mui-focused': {
      'font-size': '12px',
    },

    '& .MuiFormLabel-root.MuiFormLabel-filled': {
      'font-size': '12px',
    },

    '& .MuiFormLabel-root.Mui-error': {
      color: '#A30000',
      'font-size': '12px',
      'line-height': '15.6px',
    },

    '& label': {
      color: '#343A40',
      'font-family': 'Gotham',
      'font-size': '16px',
      'line-height': '16px',
    },

    '& .MuiInputLabel-formControl': {
      top: '-9px',
      left: '24px',
      margin: 0,
    },

    '& .MuiInputBase-input': {
      padding: '6px 24px 7px;',
      color: '#343A40',
      'font-family': 'Gotham',
      'font-weight': 400,
      'line-height': '16px',
    },

    '& .MuiInputLabel-shrink': {
      color: '#343A40',
      top: '7px !important',
      'font-weight': 325,
    },

    '& input:-internal-autofill-selected': {
      appearance: 'unset',
      '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
      padding: 0,
      margin: '6px 24px 7px',
    },

    '& input:autofill': {
      appearance: 'unset',
      '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
      padding: 0,
      margin: '6px 24px 7px',
    },

    '& input:-webkit-autofill': {
      appearance: 'unset',
      '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
      padding: 0,
      margin: '6px 24px 7px',
    },
  }
}))(TextField);

export const H1Styled = styled.h1`
  color: #475466;
  font-weight: bold;
  font-size: 40px;
  line-height: 52px;
  letter-spacing: -0.5px;
  align-self: flex-start;
  margin: 0 0 40px 24px;
`;

export const LogoStyled = styled.img`
  align-self: flex-start;
  padding: 19px 0 0 9px;
  z-index: 50;
  cursor: pointer;
`;

export const DivLogin = styled.div<CheckboxLogin>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ isCheckbox }) => isCheckbox ? 'space-between' : 'end'};
  margin: 40px 0;
`;

export const LinkStyled = styled.a<LinkStyledProps>`
  color:${({ color }) => (color || '#6C757D')} !important;
  text-decoration: ${({ textDecoration }) => (textDecoration || 'underline')};
  align-self: ${({ alignSelf }) => (alignSelf || '')};
  margin: ${({ margin }) => (margin || '')};
  cursor: pointer;
  font-family: Gotham;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  text-align: center;
`;

export const ErrorMessageStyled = styled.span`
  color: #A30000;
  font-weight: 300;
  font-size: 12px;
  line-height: 15.6px;
  margin: 2px 0 0 24px;
  align-self: flex-start;
`;

export const TitleContainerStyled = styled.div<{
  margin?: string;
}>`
  margin: ${({ margin }) => margin || '0 0 40px 24px'};
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-self: flex-start;
  
  h1 {
      margin: 0;
  }
`;